import { ImageAssets } from 'src/utils/enums/assets';

import { Scenes } from '../../utils/enums/scenes';
import { isTodayUserBirthday } from '../../utils/helpers/loadGameAssets';
import { GameScene } from '../classes/GameScene';
import { UI } from '../ui/ui';

export class Loading extends GameScene {
  startLoading = false;
  waited = false;
  apiIsCalled = false;
  defaultSeason = 'winter';

  constructor() {
    super(Scenes.LOADING);
  }

  init() {
    void this.getUser();
  }

  preload() {
    this.load.image(ImageAssets.LOADING_BACKGROUND, './assets/levels/standard/Standard_bg.png');

    this.load.audio('coinSound', './assets/sounds/game/coin.wav');
    this.load.audio('enemySound', './assets/sounds/collect-enemy/enemy.mp3');
    this.load.audio('gameOverSound', './assets/sounds/game-over/gameOver.mp3');

    [
      'winter',
      'halloween',
      'spring',
      'summer',
      'autumn',
      'valentino',
      'christmas',
      'easter',
      'programmers',
      'birthday',
      'company-birthday',
    ].forEach((season) => {
      this.load.audio(season, `./assets/sounds/${season}/backgroundSound.mp3`);
    });
  }

  create() {
    this.physics.world.setFPS(60);

    UI.images.Background(this, true);
    UI.text.Loading(this);

    this.createProgressBar();
    this.updateProgressBar(0.125);

    let percentage = 0.125;
    this.time.addEvent({
      delay: 500,
      callback: () => {
        percentage = (percentage + 0.125) % 1;
        if (!this.waited && percentage > 0.25) this.waited = true;
        this.updateProgressBar(percentage);
      },
      loop: true,
    });
  }

  createProgressBar() {
    const { width, height } = this.cameras.main;
    const w = 300;
    const h = 30;
    const x = (width - w) / 2;
    const y = (height - h) / 2;

    const box = this.add.graphics();
    box.fillStyle(0xfff8ee, 0.8);
    box.fillRect(x, y, w, h);

    const border = this.add.graphics();
    border.lineStyle(6, 0x171718, 1);
    border.strokeRect(x - 3, y - 3, w + 6, h + 6);
  }

  updateProgressBar(percentage: number) {
    const { width, height } = this.cameras.main;
    const w = 300;
    const h = 30;
    const x = (width - w) / 2;
    const y = (height - h) / 2;

    const progress = w * percentage;
    const bar = this.add.graphics();
    bar.clear();

    const layers = [
      { color: 0x23b723, height: h },
      { color: 0x35d335, height: h * 0.66 },
      { color: 0x8dff8d, height: h * 0.33 },
    ];

    for (const layer of layers) {
      bar.fillStyle(layer.color, 1);
      bar.fillRect(x, y, progress, layer.height);
    }

    const lines = 8;
    const spacing = w / lines;
    for (let i = 1; i < lines; i++) {
      bar.fillStyle(0x171718, 1);
      bar.fillRect(x + i * spacing - 3, y, 6, h);
    }
  }

  update() {
    if (!this.apiIsCalled) {
      void this.getUser();
      this.apiIsCalled = true;
    }

    if (this.user && !this.startLoading && this.waited) {
      this.startLoading = true;
      this.scene.launch(Scenes.START_MENU, { user: this.user });

      const isBirthday = isTodayUserBirthday(this);
      const season = this.user?.seasons?.seasonName ?? this.defaultSeason;
      const soundKey = isBirthday ? 'birthday' : season;

      const backgroundSound = this.sound.add(soundKey, {
        loop: true,
        volume: 0.4,
      });

      backgroundSound.play();
    }
  }
}
